import axios from "axios";
import { getAuthToken, setAuthToken, setAuthData } from "../utils/auth";
export const BASE_URL_API = "https://auth.stelmart.co.in/";

const api = axios.create({
	baseURL: "https://auth.stelmart.co.in/",
	headers: {
		"Content-Type": "application/json",
	},
});

api.interceptors.request.use((config) => {
	const token = getAuthToken();
	console.log("token============", token);
	if (token) {
		config.headers["Authorization"] = `Bearer ${token}`;
	}
	return config;
});

export const REGISTER_API = "/api/auth/register";
export const LOGIN_API = "/api/auth/login";
export const FORGET_PASSWORD_API = "/api/auth/forget-password";
export const VERIFY_OTP_API = "/api/auth/verify-otp";
export const RESET_PASSWORD_API = "/api/auth/reset-password";
export const USER_DETAILS_API = "/api/user/details";
export const PRODUCT_TYPE_API = "/api/product/get-type";
export const GET_GRADE_API = "/api/product/get-grade";
export const GET_BRAND_API = "/api/product/get-brand";
export const GET_SIZE_API = "/api/product/get-size";
export const GET_THICKNESS_API = "/api/product/get-thickness";
export const GET_LENGTH_API = "/api/product/get-length"
export const GST_VERIFY_API = "/api/gst/details";
export const PRODUCT_LIST_API = "/api/product/list";
export const PAYMENT_TERM_API = "/api/payment-term";
export const UPDATE_BUSINESS_DETAILS_API = "/api/update-business-details";
export const PRODUCT_DETAILS_API = "/api/product";
export const USER_DETAILS_UPDATE = "/api/user/update";
export const SETTING_DETAILS_API = "/api/user/setting-details";
export const ENQUIRY_POST_API = "/api/enquiries/enquiry_post";
export const GET_ADDRESS_LIST_API = "/api/address/list";
export const UPDATE_ADDRESS_API = "/api/address/update";
export const PINCODE_VERIFY_API = "/api/address/pincode";
export const VERIFY_REGISTER_OTP_API = "/api/auth/verify-register-otp";
export const GET_BUSINESS_DETAILS_SELLERS_API = "/api/seller/business-details";
export const UPDATE_SELLER_BUSINESS_DETAILS_API = "/api/seller/update-business-details";
export const GET_FINISHES_API = "/api/finishes";
export const GET_CATEGORIES_MENU_API = "/api/categories-menu";
export const GET_SPECIFICATIONS_API = "/api/specifications";
export const GET_ENDS_API = "/api/ends";
export const GET_LENGTHS_API = "/api/lengths";
export const GET_LENGTH_VALUES_API = "/api/length-values";
export const DELIVERY_TIMES_API = "/api/delivery-times";
export const ENQUIRIES_API = "/api/enquiries";
export const GET_BUYER_MY_QUOTAION_ENQUIRIES_API = "/api/enquiries/buyer-myQuotations";
export const BUYER_CANCEL_ENQUIRIES_API = "/api/enquiries/enquiry_cancel_list";
export const BUYER_EXPIRE_ENQUIRIES_API = "/api/enquiries/enquiry_exipre_list";
export const ENQUIRIES_ANALYTICS_API = "/api/enquiries/analytics";
export const SELLER_ENQUIRIES_API = "/api/seller-enquiries";
export const SELLER_MY_QUOTATION_API = "/api/enquiries/seller-myQuotations";
export const PREVIEW_ENQUIRIES_API = "/api/enquiries/sellerPreviewEnquiries";
export const PREVIEW_ENQUIRIES_API_BUYER = "/api/enquiries/previewEnquiries";
export const SELLER_QUOTATION_ENQUIRY_POST_API = "/api/enquiries/seller_quotation_enquiry_post";
export const SELLER_ENQUIRY_ANALYTICS_API = "/api/enquiries/seller-enquiryAnalytics";
export const SELLER_ENQUIRY_REJECT_API = "/api/enquiries/seller-enquiry-reject";
export const GET_REJECTED_QUOTATIONS_API = "/api/enquiries/seller-myQuotationsRejected";
export const COMPARE_BUYER_PREVIEW_API = "/api/enquiries/compareBuyerPreviewEnquiries";
export const GET_ALL_BRANDS_BY_PRODUCT_API = "/api/get-all-brands-by-product";
export const UPDATE_ENQUIRY_QUOTATION_STATUS_API = "/api/enquiry-quotation/update-status";
export const GET_ALL_BRANDS_BY_CATEGORY_API = "/api/get-all-brands-by-category";
export const SELLER_MY_CONFIRM_ORDER_API = "/api/enquiries/seller-myConfirmOrder";
export const SELLER_MY_COMPLETE_ORDER_API = "/api/enquiries/seller-myCompleteOrder";
export const SELLER_ORDER_STATUS_UPDATE_API = "/api/enquiries/seller-orderStatusUpdate";
export const QUOTATION_TRACKING_LOGS_API = "/api/enquiries/enquiry-quotations";
export const BUYER_MY_ORDER_CONFIRM_LIST_API = "/api/enquiries/buyer-myOrderConfirmList";
export const LOAN_APPLICATIONS_API = "/api/loan-applications";
export const MY_LOAN_APPLICATIONS_API = "/api/myloan-applications";
export const GRADE_API = "/api/grade";
export const DIAMETER_API = "/api/diameter";
export const VISIT_API = "/api/visit";
export const VISIT_COUNT_API = "/api/visit-count";
export const CATEGORY_DETAIL_API = "/api/category-detail";
export const BUYER_ENQUIRY_CANCEL_API = "/api/enquiries/buyer-enquiry-cancel";
export const CONTACT_ENQUIRY_API = "/api/contact-enquiry";
export const CATEGORY_SEARCH_API = "/api/category-search";
export const PURCHASE_INVOICE_API = "/api/purchase-invoice";
export const PURCHASE_ORDER_API = "/api/purchase-orders";
export const DELETE_ENQUIRY_API = "/api/enquiry-items/delete";

export const registerUser = async (userData) => {
	try {
		const response = await api.post(REGISTER_API, userData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const loginUser = async (loginData) => {
	try {
		const response = await api.post(LOGIN_API, loginData);
		const token = response.data.user.token;

		setAuthToken(token);
		setAuthData({
			token: response.data.user.token,
			user: {
				name: response.data.user.name,
				email: response.data.user.email,
				userType: response.data.user.userType,
				image: response.data.user.image,
				pan_card: response.data.user.pan_card,
				GSTIN: response.data.user.GSTIN
			}
		});


		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const forgetPasswords = async (email, userType) => {
	try {
		const response = await api.post(FORGET_PASSWORD_API, { email, userType });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const verifyOtp = async (email, userType, otp) => {
	try {
		const response = await api.post(VERIFY_OTP_API, { email, userType, otp });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const resetPassword = async (email, userType, newPassword, passwordConfirmation, token) => {
	try {
		const response = await api.post(RESET_PASSWORD_API, {
			email,
			userType,
			password: newPassword,
			password_confirmation: passwordConfirmation,
			token
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getUserDetails = async () => {
	try {
		const response = await api.get(USER_DETAILS_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getProductTypes = async () => {
	try {
		const response = await api.get(PRODUCT_TYPE_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getProductGrades = async () => {
	try {
		const response = await api.get(GET_GRADE_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getBrands = async () => {
	try {
		const response = await api.get(GET_BRAND_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getSizes = async () => {
	try {
		const response = await api.get(GET_SIZE_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getThicknesses = async () => {
	try {
		const response = await api.get(GET_THICKNESS_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getLength = async () => {
	try {
		const response = await api.get(GET_LENGTH_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const verifyGst = async (gstNumber) => {
	try {
		const response = await api.post(GST_VERIFY_API, { gstin: gstNumber });

		if (response.data === null) {
			return {
				...response,
				data: {
					flag: false,
					message: response.data?.message || ""
				}
			};
		}
		return response.data;
	} catch (error) {
		if (error.response?.data?.message) {
			throw {
				response: {
					data: {
						message: error.response.data.message
					}
				}
			};
		}
		throw { message: "" };
	}
};

export const getProductList = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.type) params.append('type', filters.type);
	if (filters.grade) params.append('grade', filters.grade);
	if (filters.brand) params.append('brand', filters.brand);
	if (filters.size) params.append('size', filters.size);
	if (filters.thickness) params.append('thickness', filters.thickness);
	if (filters.length) params.append('length', filters.length);

	console.log('Requesting with filters:', params.toString());

	return axios.get(`https://auth.stelmart.co.in${PRODUCT_LIST_API}`, {
		params: filters,
		paramsSerializer: params => {
			return Object.entries(params)
				.filter(([_, value]) => value !== undefined && value !== '')
				.map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
				.join('&');
		}
	});
};

export const getPaymentTerms = async () => {
	try {
		const response = await api.get(PAYMENT_TERM_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const updateBusinessDetails = async (businessData) => {
	try {
		const response = await api.post(UPDATE_BUSINESS_DETAILS_API, businessData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

// export const getProductDetails = async (slug) => {
//     try {
//         console.log('Fetching product with slug:', slug);

//         const response = await api.get(`${PRODUCT_DETAILS_API}/${slug}`);

//         console.log('Product details response:', response);

//         return response.data;
//     } catch (error) {
//         console.error('Error fetching product details:', error);
//         throw error.response?.data || error.message;
//     }
// };

// export const getProductDetails = async () => {
//     const slug = 'erw-pipes-electric-resistance-welded-pipes';
//     try {
//         console.log('Fetching product with slug:', slug);

//         const response = await api.get(`${PRODUCT_DETAILS_API}/${slug}`);

//         console.log('Product details response:', response);

//         return response.data;
//     } catch (error) {
//         console.error('Error fetching product details:', error);
//         throw error.response?.data || error.message;
//     }
// };
export const getProductDetails = async (slug) => {
	if (!slug) {
		throw new Error('Slug parameter is required');
	}

	try {
		console.log('Fetching product with slug:', slug);
		const response = await api.get(`${PRODUCT_DETAILS_API}/${slug}`);

		console.log('Product details response:', response);

		return response.data;
	} catch (error) {
		console.error('Error fetching product details:', error);
		throw error.response?.data || error.message;
	}
};

export const updateUserDetails = async (userData) => {
	try {
		const response = await api.post(USER_DETAILS_UPDATE, userData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};


export const getSettingDetails = async () => {
	try {
		const response = await api.get(SETTING_DETAILS_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};


export const postEnquiry = async (enquiryData) => {
	try {
		const response = await api.post(ENQUIRY_POST_API, enquiryData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getAddressList = async () => {
	try {
		const response = await api.get(GET_ADDRESS_LIST_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const updateAddress = async (id, addressData) => {
	try {
		const response = await api.post(`${UPDATE_ADDRESS_API}/${id}`, addressData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const verifyPincode = async (pincode) => {
	try {
		const response = await api.get(`${PINCODE_VERIFY_API}/${pincode}`);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const verifyRegisterOtp = async (email, otp) => {
	try {
		const response = await api.post(VERIFY_REGISTER_OTP_API, {
			email: email,
			otp: otp
		});
		return response.data;
	} catch (error) {
		console.error('API Error:', error);
		throw error.response?.data || error.message;
	}
};

export const getSellerBusinessDetails = async (businessData) => {
	try {
		const response = await api.get(GET_BUSINESS_DETAILS_SELLERS_API, businessData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const updateSellerBusinessDetails = async (formData) => {
	try {
		const response = await api.post(UPDATE_SELLER_BUSINESS_DETAILS_API, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getCategoriesMenu = async () => {
	try {
		const response = await api.get(GET_CATEGORIES_MENU_API);

		if (response.data.status && response.data.data) {
			return response.data.data;
		}
		throw new Error("Invalid response format");
	} catch (error) {
		console.error("Error fetching categories menu:", error);
		throw error.response?.data || error.message;
	}
};

export const getFinishes = async (categoryId) => {
	try {
		const response = await api.get(GET_FINISHES_API, {
			params: { category_id: categoryId }
		});
		return response.data.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getSpecifications = async (categoryId) => {
	try {
		const response = await api.get(GET_SPECIFICATIONS_API, {
			params: { category_id: categoryId }
		});
		return response.data.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getEnds = async (categoryId) => {
	try {
		const response = await api.get(GET_ENDS_API, {
			params: { category_id: categoryId }
		});
		return response.data.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getLengths = async (categoryId) => {
	try {
		const response = await api.get(GET_LENGTHS_API, {
			params: { category_id: categoryId }
		});
		return response.data.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getLengthValues = async (lengthType, categoryId) => {
	try {
		const response = await api.get(GET_LENGTH_VALUES_API, {
			params: {
				length_id: lengthType,
				category_id: categoryId
			}
		});
		return response.data.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getDeliveryTimes = async () => {
	try {
		const response = await api.get(DELIVERY_TIMES_API);
		return response.data.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getEnquiries = async (params = {}) => {
	try {
		const response = await api.get(ENQUIRIES_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getBuyerQuotationEnquiries = async (params = {}) => {
	try {
		const response = await api.get(GET_BUYER_MY_QUOTAION_ENQUIRIES_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getBuyerCancelEnquiries = async (params = {}) => {
	try {
		const response = await api.get(BUYER_CANCEL_ENQUIRIES_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getBuyerExpireEnquiries = async (params = {}) => {
	try {
		const response = await api.get(BUYER_EXPIRE_ENQUIRIES_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getEnquiriesAnalytics = async (params = {}) => {
	try {
		const response = await api.get(ENQUIRIES_ANALYTICS_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getSellerEnquiries = async (params = {}) => {
	try {
		const response = await api.get(SELLER_ENQUIRIES_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getSellerMyQuotation = async (params = {}) => {
	try {
		const response = await api.get(SELLER_MY_QUOTATION_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getPreviewEnquiry = async (enquiry_id) => {
	try {
		const response = await api.get(PREVIEW_ENQUIRIES_API, {
			params: { enquiry_id }
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};
export const getPreviewBuyerEnquiry = async (enquiry_id) => {
	try {
		const response = await api.get(PREVIEW_ENQUIRIES_API_BUYER, {
			params: { enquiry_id }
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};


export const postSellerQuotation = async (quotationData) => {
	try {
		const response = await api.post(SELLER_QUOTATION_ENQUIRY_POST_API, quotationData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getSellerEnquiryAnalytics = async (params = {}) => {
	try {
		const response = await api.get(SELLER_ENQUIRY_ANALYTICS_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const rejectSellerEnquiry = async (enquiryId) => {
	try {
		const response = await api.post(SELLER_ENQUIRY_REJECT_API, {
			enquiry_id: enquiryId
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getRejectedQuotations = async (params = {}) => {
	try {
		const response = await api.get(GET_REJECTED_QUOTATIONS_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const compareBuyerPreviewEnquiries = async (enquiryId) => {
	try {

		const response = await api.get(`${COMPARE_BUYER_PREVIEW_API}?enquiry_id=${enquiryId}`);

		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getAllBrandsByProduct = async (slug) => {
	if (!slug) {
		throw new Error('Slug parameter is required');
	}

	try {
		console.log('Fetching brands for slug:', slug);

		const response = await api.get(`${GET_ALL_BRANDS_BY_PRODUCT_API}`, {
			params: { url: slug }
		});

		console.log('Brands by product response:', response);

		return response.data;
	} catch (error) {
		console.error('Error fetching brands by product:', error);
		throw error.response?.data || error.message;
	}
};


// export const getAllBrandsByProduct = async () => {
//     const slug = 'erw-pipes-electric-resistance-welded-pipes';
//     try {
//         console.log('Fetching brands for product with slug:', slug);

//         const response = await api.get(`${GET_ALL_BRANDS_BY_PRODUCT_API}?url=${slug}`);

//         console.log('Brands by product response:', response);

//         return response.data;
//     } catch (error) {
//         console.error('Error fetching brands by product:', error);
//         throw error.response?.data || error.message;
//     }
// };


export const updateEnquiryQuotationStatus = async (statusData) => {
	try {
		const response = await api.post(UPDATE_ENQUIRY_QUOTATION_STATUS_API, statusData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getAllBrandsByCategory = async (slug) => {
	try {
		console.log('Fetching brands for category with slug:', slug);

		const response = await api.get(`${GET_ALL_BRANDS_BY_CATEGORY_API}?url=${slug}`);

		console.log('Brands by category response:', response);

		return response.data;
	} catch (error) {
		console.error('Error fetching brands by category:', error);
		throw error.response?.data || error.message;
	}
};

export const getSellerMyConfirmOrder = async (params = {}) => {
	try {
		const response = await api.get(SELLER_MY_CONFIRM_ORDER_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getSellerMyCompleteOrder = async (params = {}) => {
	try {
		const response = await api.get(SELLER_MY_COMPLETE_ORDER_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const updateSellerOrderStatus = async (quotation_id, status = {}) => {
	try {
		const response = await api.post(SELLER_ORDER_STATUS_UPDATE_API, {
			quotation_id: quotation_id,
			...status
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getQuotationTrackingLogs = async (quotationId) => {
	try {
		const response = await api.get(`${QUOTATION_TRACKING_LOGS_API}/${quotationId}/tracking-logs`);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};


export const getBuyerMyOrderConfirmList = async (params = {}) => {
	try {
		const response = await api.get(BUYER_MY_ORDER_CONFIRM_LIST_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};


export const createLoanApplication = async (loanData) => {
	try {
		const response = await api.post(LOAN_APPLICATIONS_API, loanData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getMyLoanApplications = async (params = {}) => {
	try {
		const response = await api.get(MY_LOAN_APPLICATIONS_API, { params });
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getGrades = async (id) => {
	try {
		const response = await api.get(`${GRADE_API}?id=${id}`);
		console.log("ID_Response", response);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getDiameters = async (id) => {
	try {
		const response = await api.get(`${DIAMETER_API}?id=${id}`);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const createVisit = async (visitData) => {
	try {
		const response = await api.post(VISIT_API, visitData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getVisitCount = async () => {
	try {
		const response = await api.get(VISIT_COUNT_API);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const getCategoryDetail = async (slug) => {
	try {
		const response = await api.get(CATEGORY_DETAIL_API, {
			params: { url: slug },
		});
		return response.data;
	} catch (error) {
		console.error('Error fetching category detail:', error);
		throw error.response?.data || error.message;
	}
};

export const cancelBuyerEnquiry = async (enquiryId) => {
	try {
		const response = await api.post(BUYER_ENQUIRY_CANCEL_API, {
			enquiry_id: enquiryId
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const submitContactEnquiry = async (enquiryData) => {
	try {
		const response = await api.post(CONTACT_ENQUIRY_API, enquiryData);
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const searchCategories = async (name) => {
	try {
		const response = await api.get(CATEGORY_SEARCH_API, {
			params: { name }
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const createPurchaseInvoice = async (invoiceData) => {
	try {
		const response = await api.post(PURCHASE_INVOICE_API, invoiceData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

export const createPurchaseOrder = async (invoiceData) => {
	try {
		const response = await api.post(PURCHASE_ORDER_API, invoiceData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		});
		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};

// export const deleteEnquiryOrItem = async (enquiryId, itemId = null) => {
// 	try {
// 		if (!itemId) {
// 			const response = await api.get(`/api/enquiry-items/delete?id=${enquiryId}`);
// 			return response.data;
// 		}
// 		else {
// 			const response = await api.get(
// 				`/api/enquiry-items/delete?id=${enquiryId}&enquiry_id=${itemId}`
// 			);
// 			return response.data;
// 		}
// 	} catch (error) {
// 		throw error.response?.data || error.message;
// 	}
// };

export const deleteEnquiryOrItem = async (enquiryId, itemId = null) => {
	try {
		const params = new URLSearchParams();
		params.append('id', enquiryId);
		if (itemId) {
			params.append('enquiry_id', itemId);
		}

		const response = await api.get(`/api/enquiry-items/delete?${params.toString()}`);

		if (response.data.status !== true) {
			throw new Error(response.data.message || "Delete operation failed");
		}

		return response.data;
	} catch (error) {
		throw error.response?.data || error.message;
	}
};


export default api;
